import api from "../api";

// New APIs
export const fetchWatomsRelatedVtcs = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/vtcs`);
    return response?.data?.vtcs || [];
  } catch (error) {
    console.error('Error fetching Watoms Detailed Data:', error);
    throw error;
  }
}

// Watoms Related Organizations
export const fetchWatomsRelatedOrganizations = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/data/orgs`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.organizations || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.organizations || error.message
    );
    throw error;
  }
};

export const createCandidateUser = async (payload) => {
  try {
    const response = await api.post(`/api/v1/watoms/pe/candidate/create-user`, payload, {
      // IMPORTANT: don't set Content-Type manually when payload is FormData
      // axios will set multipart/form-data with boundary automatically
    });
    return response.data;
  } catch (error) {
    console.error("Error creating candidate:", error.response?.data || error.message);
    throw error;
  }
};

export const updateCandidateUser = async (formData, id) => {
  try {
    const response = await api.patch(`/api/v1/watoms/pe/candidate/update-user/${id}`, formData);
    return response.data;
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const fetchAllCandidates = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/pe/candidates`);
    return response?.data?.candidates || [];
  } catch (error) {
    console.error('Error fetching Watoms Detailed Data:', error);
    throw error;
  }
}

export const createEmployeePerformaceReport = async (formData) => {
  try {
    const response = await api.post(`/api/v1/watoms/pr/create-report`, formData);
    return response.data;
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const fetchEmployeePerformaceReport = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/pr/individuals-data`);
    return response.data.reports;
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const fetchTraineesAttendance = async () => {
  try {
    const response = await api.get(`/api/v1/users/students/absence`);
    return response.data.data;
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// fetch watoms' subjects
export const fetchWatomsSubjects = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/subjects`);
    return response.data.subjects || [];
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// fetch watoms' subjects
export const fetchWatomsTrainers = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/trainers`);
    return response.data.trainers || [];
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// fetch watoms' classes
export const fetchWatomsClasses = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/all-classes`);
    return response.data.classes || [];
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// fetch watoms' organizations' curriculums
export const fetchWatomsCurriculumsPerOrg = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/orgs-curriculums`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.curriculums || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// fetch watoms' subjects
export const fetchWatomsRelatedSubjects = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/related-subjects`);
    return response.data.subjects || [];
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// Trainees Registration Form
export const insertTrainerRegistrationForm = async (formData) => {
  try {
    return await api.post("/api/v1/watoms/trainers/registration", formData);
  } catch (error) {
    console.error("Error creating form:", error.response?.data || error.message);
    throw error;
  }
};

// fetch watoms' employees
export const fetchWatomsRelatedEmployees = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/data/employees`);
    return response.data.employees || [];
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// fetch Watoms' Courses Detailed
export const fetchWatomsRelatedCoursesDetailed = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/data/courses`);
    return response.data.courses || [];
  } catch (error) {
    console.error(
      "Error creating form:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// fetch watoms' curriculums' orgs
export const fetchWatomsCurriculumsOrgsRelation = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/data/curriculums-orgs`, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data?.curriculums || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// fetch watoms related specializations
export const fetchWatomsRelatedSpecializations = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/data/specializations`);
    return response.data?.specializations || [];
  } catch (error) {
    console.error(
      "Error fetching forms:",
      error.response?.data || error.message
    );
    throw error;
  }
};

// New APIs
export const fetchWatomsRelatedClassRooms = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/data/classrooms`);
    return response?.data?.classrooms || [];
  } catch (error) {
    console.error('Error fetching Watoms Detailed Data:', error);
    throw error;
  }
}

// New APIs
export const fetchWatomsSystemSurveyForm = async () => {
  try {
    const response = await api.get(`/api/v1/watoms/data/system-servey`);
    return response?.data?.survey || [];
  } catch (error) {
    console.error('Error fetching Watoms Detailed Data:', error);
    throw error;
  }
}

// Trainees Registration Form
export const insertWatomsManagersSurveyForm = async (data) => {
  try {
    return await api.post("/api/v1/watoms/system-survey-form", data);
  } catch (error) {
    console.error("Error creating form:", error.response?.data || error.message);
    throw error;
  }
};